import React, { useState } from "react";
import SearchBar from "shared/components/SearchBar";

const ScheduleCalendar = () => {
  const [year, setYear] = useState(2025);
  const [month, setMonth] = useState(11);
  const [selectedLocation, setSelectedLocation] =
    useState("새마을상점(01-002)");

  // Generate calendar days
  const generateCalendarDays = () => {
    const daysInMonth = new Date(year, month, 0).getDate();
    const firstDay = new Date(year, month - 1, 1).getDay();

    // Get last days of previous month to fill the first row
    const prevMonthDays = new Date(year, month - 1, 0).getDate();

    const days = [];

    // Previous month days
    for (let i = prevMonthDays - firstDay + 1; i <= prevMonthDays; i++) {
      const hasEvent = [28, 29, 30, 31].includes(i);
      const hasBlueEvent = [28, 30].includes(i);
      days.push({ day: i, currentMonth: false, hasEvent, hasBlueEvent });
    }

    // Current month days
    for (let i = 1; i <= daysInMonth; i++) {
      // Mark special days (for demo purposes, marking days 1)
      const hasEvent = [1].includes(i);
      const hasBlueEvent = [1].includes(i);
      days.push({ day: i, currentMonth: true, hasEvent, hasBlueEvent });
    }

    // Next month days to fill the last row
    const remainingCells = 42 - days.length; // 6 rows of 7 days
    for (let i = 1; i <= remainingCells; i++) {
      days.push({
        day: i,
        currentMonth: false,
        hasEvent: false,
        hasBlueEvent: false,
      });
    }

    return days;
  };

  const days = generateCalendarDays();

  // Days of the week in Korean
  const daysOfWeek = ["일", "월", "화", "수", "목", "금", "토"];

  return (
    <div className="calendar-container">
      <SearchBar />
      <div className="htContent">
        <div className="location-dropdown">
          <select
            value={selectedLocation}
            onChange={(e) => setSelectedLocation(e.target.value)}
          >
            <option value="새마을상점(01-002)">새마을상점(01-002)</option>
          </select>
        </div>

        <div className="date-selector">
          <select
            value={year}
            onChange={(e) => setYear(parseInt(e.target.value))}
          >
            <option value="2025">2025</option>
            <option value="2024">2024</option>
          </select>

          <select
            value={month}
            onChange={(e) => setMonth(parseInt(e.target.value))}
          >
            {Array.from({ length: 12 }, (_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>
        </div>

        <div className="calendar">
          <div className="calendar-header">
            {daysOfWeek.map((day, index) => (
              <div key={index} className="calendar-cell header">
                {day}
              </div>
            ))}
          </div>

          <div className="calendar-grid">
            {days.map((day, index) => (
              <div
                key={index}
                className={`calendar-cell ${!day.currentMonth ? "other-month" : ""
                  }`}
              >
                <div className="day-number">{day.day}</div>
                {day.hasEvent && <div className="event-indicator red"></div>}
                {day.hasBlueEvent && <div className="event-indicator blue"></div>}
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  );
};

export default ScheduleCalendar;
